import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import {CfgARToothModel} from '../../../models/accountsReceivable/cfg-ar-tooth.model';

export class PostTransactionItemsObj {
  LOCID: number;
  PatientId: string;

  transactionItems: dataARTransactionItem[];
}

export class PostCreatePaymentForLedger {
  InvoiceId: string;
  LedgerID: string;
  paymentAmount: number;
  enumPaymentTypeID: string;
  enumPaymentSourceID: string;
  Description: string;

  ledgerItems: dataARLedger[];
}

// export class WorldPayPaymentObj {
//   MerchantID: string;
//   Password: string;
//   TranType: string;
//   PartialAuth: string;
//   TotalAmount: number;
//   Invoice: string;
//   Frequency: string;
//   Memo: string;
//   ReturnUrl: string;
//   ProcessCompleteUrl: string;
// }

export class InvoiceStringObj {
  invoiceString: string;
}

export class cfgARAccount {
  ARAccountID: string;
  AccountName: string;
  AccountNumber: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class cfgARMerchantAccount {
  MerchantAccountID: string;
  LOCID: number;
  AccountName: string;
  AccountID: string;
  AccountPassword: string;
  isDefault: boolean;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class cfgCaseProcedure {
  CaseProcedureId: string;
  TDOCID: number;
  ProcedureName: string;
  Code: string;
  Description: string;
  ResultingConditionID: string;
  ParentCaseProcedureId: string;
  HasChildren: boolean;
  PresentOrder: number;
  enumProcedureCategoryID: string;
  enumMedicalSpecialtyID: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_SELECTED: boolean;
}

export class CaseForTooth {
      PatientId: string;
      ToothId: string;
      CaseProcedureId: string;
      Description: string;
      DoctorId: string;
      ReferralDoctorId: string;
      enumCaseStatusID: string;    
}

export class cfgTDOUser {
  UserID: string;
  TDOCID: number;
  UserName: string;
  UserPassword: string;
  UserNickName: string;
  enumSalutationID: string;
  FirstName: string;
  MidName: string;
  LastName: string;
  ContactId: string;

  dataContact: dataContact;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataARClaim {
  ARClaimID: string;
  ClaimDate: Date;
  PatientInsuranceID: string;
  enumClaimStatusID: string;
  LOCID: number;
  enumClaimTypeID: string;

  dataARClaimItems: dataARClaimItem[];
  dataPatientInsurance4AR: dataPatientInsurance;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_PATIENT: dataPatient;
}

export class dataARClaimItem {

  ARClaimItemID: string;
  ARClaimID: string;
  ARTransactionItemID: string;

  dataARTransactionItem: dataARTransactionItem;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataARLedger {
  LedgerID: string;
  LOCID: number;
  PatientId: string;
  PostDate: Date;
  enumARLedgerItemTypeID: string;
  ARTransactionItemID: string;
  Amount: number;
  Description: string;
  enumCurrencyID: string;
  ARAccountID: string;
  enumLedgerItemStatusID: string;

  cfgARAccount: cfgARAccount;
  dataARTransactionItem: dataARTransactionItem;
  xauditCreateByUser: cfgTDOUser;
  dataARPaymentDistribs: dataARPaymentDistrib[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_SELECTED: boolean;
  DATA_SELECTED_CLAIM: boolean;
  DATA_PAYMENT_AMOUNT: string;
  dataARPaymentDistrib: dataARPaymentDistrib;
  DATA_ENABLE_PRICE_EDIT: boolean;
  DATA_SHOW_NOTES: boolean;
  DATA_IS_IN_PLAN: boolean;
}

export class dataARPayment {
  PaymetnID: string;
  PaymentTransactionDate: Date;
  Description: string;
  enumPayementTypeID: string;
  PaymentAmount: number;
  enumCurrencyID: string;
  PaymentReferenceObjectiD: string;
  enumPaymentSourceID: string;
  PaymentSourceObjectID: string;
  PaymentInvoiceObject: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_DATE: Date;
}

export class dataARPaymentDistrib {
  PaymetnDistributionID: string;
  PaymetnID: string;
  LedgerID: string;
  Amount: number;
  enumCurrencyID: string;

  dataARPayment: dataARPayment;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataARTransaction {
  ARTransactionID: string;
  LOCID: number;
  PatientId: string;
  TransactionDate: Date;
  Reference: string;
  enumARTransStatus: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataARTransactionItem {
  ARTransactionItemID: string;
  ARTransactionID: string;
  CaseWorkItemId: string;
  Code: string;
  enumARItemStatusID: string;
  Price: number;
  PriceAdjusted: number;
  enumCurrencyID: string;
  FeeScheduleItemID: string;
  ItemOrder: number;
  Description: string;
  enumFeeItemCategoryId: string;
  CoveragePCT: number;
  CoverageAmount: number;
  enumFeeCoverageCalcTypeId: string;
  DiscountPCT: number;
  DiscountAmount: number;
  enumFeeDiscountCalcTypeId: string;
  WorkItemEventId: string;
  ProviderDoctorId: string;

  dataARClaims: dataARClaim[];
  dataARTransaction: dataARTransaction;
  dataPatientCaseWorkItem: dataPatientCaseWorkItem;
  dataDoctor: dataDoctor;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_POST: boolean;
  DATA_SELECTED_CLAIM: boolean;
  DATA_COVERAGE: string;
  DATA_SELECTED_TOOTH: string;
  DATA_PROCEDURE_NAME: string;
  DATA_POST_DATE: Date;
  DATA_DOCTOR_FEE_SCHEDULE: dataFeeScheduleDoctor;
  DATA_DOCTOR_FEE_SCHEDULES: dataFeeScheduleDoctor[];
  DATA_ACTIVE_DoctorFee: dataFeeScheduleItemFee;
  DATA_ACTIVE_PatientCoverage: dataPatientInsuranceCoverage;
  DATA_PatientCoverages: dataPatientInsuranceCoverage[];
  DATA_ENABLE_PRICE_EDIT: boolean;
  DATA_ENABLE_TOOTH_EDIT: boolean;
}

export class dataContact {
  ContactId: string;
  LOCID: number;
  enumSalutationID: string;
  Description: string;
  FirstName: string;
  MidName: string;
  LastName: string;
  AKA: string;
  enumContactCategoryID: string;
  enumNameSuffixID: string;
  enumGenderID: string;
  GovermentIdentificationNo1: string;
  GovermentIdentificationNo2: string;
  GovermentIdentificationNo3: string;
  isVisibleGovermentIdentificationNo1: boolean;
  isVisibleGovermentIdentificationNo2: boolean;
  isVisibleGovermentIdentificationNo3: boolean;
  ValidValueItemId: string;
  BirthDate: Date;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataFeeSchedule {
  FeeScheduleID: string;
  TDOCID: number;
  OrganizationID: string;
  FeeScheduleName: string;
  enumFeeScheduleTypeId: string;
  PatientInsuranceID: string;

  dataFeeScheduleItems: dataFeeScheduleItem[];
  dataInsurances: dataInsurance[];
  dataFeeScheduleDoctors: dataFeeScheduleDoctor[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataFeeScheduleDoctor {
  DocFeeScheduleID: string;
  FeeScheduleID: string;
  DoctorId: string;
  Description: string;

  dataFeeScheduleItemFees: dataFeeScheduleItemFee[];
  // dataFeeSchedule: dataFeeSchedule;
  dataDoctor: dataDoctor;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataFeeScheduleItem {
  FeeScheduleItemID: string;
  FeeScheduleID: string;
  ItemOrder: number;
  Code: string;
  Description: string;
  Fee: number;
  enumFeeItemCategoryId: string;
  ParentFeeScheduleItemID: string;
  CoveragePCT: number;
  CoverageAmount: number;
  isCustom: boolean;
  enumFeeCoverageCalcTypeId: string;
  isExplosion: boolean;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataFeeScheduleItemFee {
  DocFeeScheduleItemID: string;
  FeeScheduleItemID: string;
  DocFeeScheduleID: string;
  Fee: number;

  dataFeeScheduleItem: dataFeeScheduleItem;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataInsurance {
  InsuranceID: string;
  TDOIC: number;
  OrganizationID: string;
  Description: string;
  PayerID: string;
  GroupNO: string;
  EmployerNO: string;
  FeeScheduleID: string;

  dataOrganization: dataOrganization;
  dataPatientInsuranceCoverages: dataPatientInsuranceCoverage[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataInsuranceExplosion {
  ExplosionID: string;
  TDOCID: number;
  OrganizationID: string;
  Name: string;

  dataInsuranceExplosionCodes: dataInsuranceExplosionCode[];
  dataOrganization: dataOrganization;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataInsuranceExplosionCode {
  ExplosionCodeID: string;
  ExplosionID: string;
  Code: string;
  ItemOrder: number;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_SELECTED: boolean;
}

export class dataOrganization {
  OrganizationID: string;
  TDOIC: number;
  OrganizationName: string;
  AddressId: string;
  enumOrganizationTypeId: string;

  dataFeeSchedules: dataFeeSchedule[];
  dataInsuranceExplosions: dataInsuranceExplosion[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataPatient {
  PatientId: string;
  LOCID: number;
  PatientNO: string;
  BirthDate: Date;
  enumOccupationID: string;
  ContactId: string;
  WebID: string;
  WebPassword: string;
  enumLanguageID: string;
  enumCommMethodID: string;
  isDeceased: boolean;
  ChartNo: string;
  enumPatientAppointmentID: string;
  isDoNotSchedule: boolean;
  isDoNotEverTreatAgain: boolean;
  isSentCollection: boolean;
  isChargeInterest: boolean;
  isOnPaymentPlan: boolean;

  dataContact: dataContact;
  dataPatientCases: dataPatientCase[];
  dataPatientInsurances: dataPatientInsurance[];
  dataPatientContacts: dataPatientContact[];
  enumCommMethod: enumValidValueItem;
  enumLanguage: enumValidValueItem;
  enumOccupation: enumValidValueItem;
  enumPatientAppointment: enumValidValueItem;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

// TODO: Replace with PatientCaseDataModel
export class dataPatientCase {
  PatientCaseId: string;
  PatientId: string;
  LOCID: number;
  Description: string;
  TreatmentPlanningID: string;
  ReferringDoctorContactID: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class cfgTooth {
  ToothId: string;
  Name: string;
  enumToothLocationId: string;
  PhysicalVorder: number;
  PhysicalHorderLR: number;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataPatientCaseWorkItem {
  CaseWorkItemId: string;
  PatientCaseId: string;
  LOCID: number;
  PatientCasePhaseID: string;
  ToothID: string;
  CaseProcedureId: string;
  Description: string;

  dataPatientCase: dataPatientCase;
  cfgCaseProcedure: cfgCaseProcedure;
  cfgTooth: cfgTooth;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataPatientContact {
  PatientId: string;
  ContactId: string;
  enumPatientContactTypeID: string;

  dataContact: dataContact;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataPatientInsurance {
  PatientInsuranceID: string;
  PatientId: string;
  InsuranceID: string;
  EmployerNO: string;
  GroupNO: string;
  InsuranceOrder: number;
  CoverageStart: Date;
  CoverageEnd: Date;
  PatientInsuranceNO: string;
  SubsciberContactId: string;
  enumInsuranceRelationId: string;
  SubsciberBirthdate: Date;
  BenefitsChangedOn: Date;
  BenefitsNonDuplication: boolean;
  BenefitsMaximum: number;
  BenefitsLeft: number;
  BenefitsDeductableLeftPreventitive: number;
  BenefitsDeductableLeftStandard: number;
  BenefitsDeductableLeftOther: number;
  CaseWorkItemFormsId: string;

  dataFeeSchedules: dataFeeSchedule[];
  dataPatient: dataPatient;
  dataInsurance: dataInsurance;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataPatientInsuranceCoverage {
  CoverageID: string;
  InsuranceID: string;
  Code: string;
  enumFeeItemCategoryId: string;
  CoveragePCT: number;
  CoverageAmount: number;
  enumFeeCoverageCalcTypeId: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_DoctorFees: dataFeeScheduleItemFee[];
}

export class enumValidValue {
  ValidValueId: string;
  ValidValueName: string;
  TDOCID: number;
  isSystem: boolean;

  enumValidValueItems: enumValidValueItem[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class enumValidValueItem extends EnumValidValueItemModel {

}

export class LOCIDForPaymentObj {
  LOCID: number;
  PaymentID: string;
}

// export class WorldPayTransactionRef {
//   TransactionSetupID: string;
// }

// export class WorldPayTransactionRef {
//   PaymentID: string;
// }

export class dataAppointment {
  AppointmentId: string;
  LOCID: number;
  enumApptTypeId: string;
  enumApptStatusId: string;
  PatientId: string;
  Resource_OperatoryId: string;
  Label_DoctorId: string;
  Subject: string;
  Description: string;
  StartDate: Date;
  EndDate: Date;
  Duration: number;
  isAllDay: boolean;
  isFirstVisit: boolean;
  CaseProcedureId: string;
  isExistingCase: boolean;
  PatientCaseId: string;
  CaseWorkItemId: string;
  NoteGroupId: string;
  ReminderInfo: string;
  RecurrenceInfo: string;

  dataDoctor4Info: any; // not needed, leaving as any

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

}

export class dataDoctor {
  DoctorId: string;
  LOCID: number;
  ContactId: string;
  Title: string;
  UserId: string;
  ReportName: string;
  NoteGroupId: string;
  enumDoctorTypeID: string;
  enumDoctorClassificationID: string;
  TaxID: string;
  DEA: string;

  dataContact: dataContact;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class ClaimCreationObj {
  ClaimDate: Date;
  PatientInsuranceID: string;
  transactionItems: dataARTransactionItem[];
  enumClaimTypeID: string;
}

export class dataARPaymentPlan {
  PaymentPlanID: string;
  PatientId: string;
  TotalAmount: number;
  Description: string;
  enumPaymentTypeID: string;
  enumPaymentPlanStatusID: string;
  isPatientAccepted: boolean;
  AcceptedDate: Date;

  dataARPaymentPlanItems: dataARPaymentPlanItem[];
  dataARPaymentPlanLedgerItems: dataARPaymentPlanLedgerItem[];

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;

  DATA_PLAN_AMOUNT: number;
  DATA_SELECTED: boolean;
  DATA_IS_PAID: boolean;
}

export class dataARPaymentPlanItem {
  PaymentPlanItemID: string;
  PaymentPlanID: string;
  Description: string;
  DueDate: Date;
  Amount: number;
  enumPaymentPlanItemStatusID: string;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}

export class dataARPaymentPlanLedgerItem {
  PaymentPlanTransID: string;
  PaymentPlanID: string;
  LedgerID: string;

  dataARLedger: dataARLedger;

  xauditDeleted: boolean;
  xauditTableRowID: string;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
}


// accounting integration eg. QuickBooks
export class aiTrasacion  {

  LedgerID : string;
  PatientNo: string;
  AIRef: string;
  AICustomer: string;
  LastTran: string;
  NTC: string;
  RecType: string;
  PrevBalance: string;
  TDObalance: string;
  AIBalance: string;

  trStatus: number ;
}

export class aiDoctor {
  DoctorID: string;
  FullName: string;
  enumARSystemIntegrationID: string;
  iconpath: string; 
}


